import React from 'react';


/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 *
 * ResumeInfoCard Component
 *
 * Reusable card component for rendering resume/information sections.

 * PROPS:
 * @param {string} title - Title displayed in the card header.
 * @param {ReactNode} titleIcon - Icon displayed next to the title.
 * @param {ReactNode} icon - Main icon displayed on the left side.
 * @param {ReactNode} body - Dynamic body content rendered inside the card.
 * @param {string} iconBackground - Background class for the icon container.
 * @param {string} cardClassName - Custom classes for the CustomCard wrapper.
 * @param {ReactNode} titleActions - Content aligned to the right of the title, for the actions of the section.
 */

const ResumeInfoCard = ({
    title,
    titleIcon,
    icon,
    body,
    iconClass = 'background-primary-100',
    contentClass='',
    titleActions = null
}) => {
    return (
        <div className={"background-general-00 border-radius-8px border-full-shades-300 p-0"}>
            <div className={"d-flex align-items-center p-3"}>
                {titleIcon && <div className='mr-2'>{titleIcon}</div>}

                <p className='font-color-general-950 ibl-font-w-600 fs-14-to-13 mb-0'>
                    {title}
                </p>

                {titleActions && <div className='ml-auto d-flex align-items-center gap-2'>{titleActions}</div>}
            </div>
            <div className={"border-bottom-shades-300 w-100"}/>
            <div className={`col-12 ${contentClass}`}>
                <div className='row'>
                    <div className='col-auto px-0'>
                        <div
                            className={`p-8px border-radius-8px d-flex w-44px h-44px
                                    justify-content-center align-items-center ${iconClass}`}
                        >
                            {icon}
                        </div>
                    </div>
                    <div className='col'>
                        {body}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResumeInfoCard;
